import * as RadixDialog from '@radix-ui/react-dialog'
import { X } from 'lucide-react'
import { forwardRef, type ComponentPropsWithoutRef, type ReactNode } from 'react'
import { cn } from '@/lib/cn'
import { IconButton } from '@/components/ui/IconButton'
import styles from './Dialog.module.scss'

export const DialogRoot = RadixDialog.Root
export const DialogTrigger = RadixDialog.Trigger
export const DialogClose = RadixDialog.Close

export interface DialogContentProps
  extends Omit<ComponentPropsWithoutRef<typeof RadixDialog.Content>, 'title'> {
  title: ReactNode
  description?: ReactNode
  children: ReactNode
  footer?: ReactNode
  hideClose?: boolean
  /** Controles no cabeçalho, à esquerda do X (ex.: o toggle "Ativo"). */
  headerActions?: ReactNode | undefined
  /** Faixa fixa entre o cabeçalho e o corpo, que não rola com ele (ex.: abas). */
  subheader?: ReactNode | undefined
  /** Classe extra do corpo rolável. */
  bodyClassName?: string | undefined
}

export const DialogContent = forwardRef<HTMLDivElement, DialogContentProps>(function DialogContent(
  { title, description, children, footer, hideClose, headerActions, subheader, bodyClassName, className, ...rest },
  ref,
) {
  return (
    <RadixDialog.Portal>
      <RadixDialog.Overlay className={styles.overlay} />
      <RadixDialog.Content ref={ref} className={cn(styles.content, className)} {...rest}>
        <div className={styles.header}>
          <div className={styles.headerText}>
            <RadixDialog.Title className={styles.title}>{title}</RadixDialog.Title>
            {description ? (
              <RadixDialog.Description className={styles.description}>
                {description}
              </RadixDialog.Description>
            ) : null}
          </div>
          {headerActions ? <div className={styles.headerActions}>{headerActions}</div> : null}
          {!hideClose ? (
            <RadixDialog.Close asChild>
              <IconButton aria-label="Fechar" variant="ghost">
                <X />
              </IconButton>
            </RadixDialog.Close>
          ) : null}
        </div>
        {subheader}
        <div className={cn(styles.body, bodyClassName)}>{children}</div>
        {footer ? <div className={styles.footer}>{footer}</div> : null}
      </RadixDialog.Content>
    </RadixDialog.Portal>
  )
})
